import { RouteView } from '@/layouts';

const exchangeRouter = {
  path: '/exchange',
  name: 'Exchange',
  redirect: '/exchange/list',
  component: RouteView,
  meta: {
    title: '积分商城',
    icon: 'icondiscount',
    roles: ['admin'],
  },
  children: [
    {
      path: 'intergral-goods',
      name: 'ExchangeIntergralGoods',
      component: RouteView,
      redirect: '/exchange/intergral-goods/list',
      hideChildrenInMenu: true,
      meta: {
        title: '积分商品',
        icon: 'icon-shangpin',
        roles: ['admin'],
      },
      children: [
        {
          path: 'list',
          name: 'ExchangeList',
          component: () => import('@/views/exchange/List'),
          meta: {
            title: '兑换商城列表',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'add',
          name: 'ExchangeAdd',
          component: () => import('@/views/exchange/Add'),
          meta: {
            title: '添加商品',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'editor',
          name: 'ExchangeEditor',
          component: () => import('@/views/exchange/Editor'),
          meta: {
            title: '兑换商品编辑',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    },
    {
      path: 'order',
      name: 'ExchangeOrder',
      component: RouteView,
      redirect: '/exchange/order/list',
      hideChildrenInMenu: true,
      meta: {
        title: '积分订单',
        icon: 'icon-kefujingli-',
        roles: ['admin'],
      },
      children: [
        {
          path: 'list',
          name: 'ExchangeOrderList',
          component: () => import('@/views/exchange/OrderList'),
          meta: {
            title: '订单列表',
            roles: ['admin'],
            hidden: true,
          },
        },
        {
          path: 'detail',
          name: 'ExchangeOrderDetail',
          component: () => import('@/views/exchange/OrderDetail'),
          meta: {
            title: '订单详情',
            roles: ['admin'],
            hidden: true,
          },
        },
      ],
    },
  ],

};

export default exchangeRouter;
